import { Batch, BatchStatus } from "@wingspanhq/wingspan-api-sdk";

type Args = {
  batch?: Batch;
  /** `BatchSummary.progress.failed`. */
  failedCount?: number;
};

// v3 has no PartiallyCompleted status, so the failed count is what separates
// a partial import from a clean one.
export const selectorIsImportBatchPartiallyImported = (args: Args): boolean =>
  args.batch?.status === BatchStatus.COMPLETED && (args.failedCount || 0) > 0;
